"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const whatsNewPopup_1 = __importDefault(require("../../../shared/components/whatsNew/whatsNewPopup"));
const whatsNewSlice_1 = require("../../../redux/slices/whatsNewSlice");
class WhatsNewContainer extends react_1.Component {
    componentDidMount() {
        this.props.getLatestWhatsNew();
        this.props.toggleDetailsModal();
    }
    render() {
        const { singleWhatsNew } = this.props.whatsNew;
        return (react_1.default.createElement(react_1.Fragment, null, singleWhatsNew.id && react_1.default.createElement(whatsNewPopup_1.default, { adminView: false })));
    }
}
const mapStateToProps = (state) => {
    const { whatsNew } = state;
    return {
        whatsNew
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getLatestWhatsNew: () => dispatch(whatsNewSlice_1.getLatestWhatsNew()),
        toggleDetailsModal: () => dispatch(whatsNewSlice_1.toggleDetailsModal())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(WhatsNewContainer);
